import React, { useState, useEffect } from 'react';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { SingleText, SingleRedio, isDisableItems, SingleInput, SingleSelect } from '../../Res/BaseInput';
import { CancelSubmitButton } from '../../Res/BaseButton';
import Swal from 'sweetalert2';
import { getResume2Token, getUserInfoCompanyId, getval2Token } from '../../../Login/Auth';
import { api_getDepartmentDetail, api_getDepartmentList, api_updateDepartment } from '../../../../api/apiDepartment';
import { ReqDepartmentDetail, ReqDepartmentList, RespDepartmentDetail, ReqUpdateDepartment } from '../../../../item/ItemDepartment';
import { DepartmentPositionList } from './DepartmentPositionList';
import { ReqCategoryList, ReqCategoryItem } from '../../../../item/ItemCategory';
import { api_getCategoryList } from '../../../../api/apiCategory';

export function DepartmentDetail({ id, setIsLoading, isEdit }) {
    const [companyId] = useState(getUserInfoCompanyId())
    const [departmentId, setDepartmentId] = useState("")

    const [departmentName, setDepartmentName] = useState("")
    const [managerDepartmentId, setManagerDepartmentId] = useState("")
    const [managerDepartmentName, setManagerDepartmentName] = useState("")
    const [managerDepartmentList, setManagerDepartmentList] = useState([])
    const [isDisable, setIsDisable] = useState(1)

    const [categoryId, setCategoryId] = useState("")
    const [categoryName, setCategoryName] = useState("")

    const [positionList, setPositionList] = useState([])
    const [categoryList, setCategoryList] = useState([])

    const [mRespDepartmentDetail, setRespDepartmentDetail] = useState({})

    useEffect(() => {
        var rId = getval2Token("departmentId", id)
        // var rId = getResume2Token(id)
        setDepartmentId(rId)
        if (isEdit) {
            var mReqDepartmentList = new ReqDepartmentList({ companyId })
            getDepartmentList(mReqDepartmentList)
            getCategoryList()
        }
    }, [])


    async function getDepartmentList(mReqDepartmentList) {
        setIsLoading(true)
        api_getDepartmentList({
            mReqDepartmentList,
            success: (obj) => {
                //console.log(obj)
                setManagerDepartmentList(obj.list)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
            }
        })
    }

    async function getCategoryList() {
        var mReqCategoryList = new ReqCategoryList({type:"Department"})
        setIsLoading(true)
        api_getCategoryList({
            mReqCategoryList,
            success: (obj) => {
                //console.log(obj)
                setCategoryList(obj.list)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
            }
        })
    }

    useEffect(() => {
        if (departmentId === "")
            return
        //console.log("api_getAdminDetail")
        setIsLoading(true)
        var mReqDepartmentDetail = new ReqDepartmentDetail({
            companyId, departmentId
        })
        //console.log(mReqDepartmentDetail)
        api_getDepartmentDetail({
            mReqDepartmentDetail,
            success: (result) => {
                console.log(result)
                var detail = new RespDepartmentDetail({})
                detail.fromJson(result.detail)
                //console.log(detail)
                //console.log(result.roles)
                setRespDepartmentDetail(detail)
                setPositionList(result.roles)
                setDepartmentName(detail.departmentName)
                setManagerDepartmentId(detail.managerDepartmentId)
                setManagerDepartmentName(detail.managerDepartmentName)
                setIsDisable(detail.isDisable)
                setCategoryId(detail.categoryId)
                setCategoryName(detail.categoryName||"--")
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
            }
        })
    }, [departmentId])

    function toEdit() {
        window.location.assign("/DepartmentEdit/" + id);
    }

    function toCancel() {
        window.history.go(-1)
    }

    function saveDetail() {
        var mReqUpdateDepartment = new ReqUpdateDepartment({
            companyId,
            departmentId,
            departmentName,
            managerDepartmentId,
            isDisable: isDisable === mRespDepartmentDetail.isDisable ? undefined : isDisable,
            categoryId
        })
        api_updateDepartment({
            mReqUpdateDepartment,
            success: (jsonData) => {
                //console.log(jsonData)
                Swal.fire({
                    type: 'success',
                    title: '編輯成功',
                    //text: '編輯成功',
                }).then(() => {
                    window.location.assign("/DepartmentDetail/" + id);
                })
            },
            failure: (err) => {
                Swal.fire({
                    type: 'error',
                    title: '上傳失敗',
                    text: err.message
                })
            }
        })
    }

    var title = '部門資訊'
    var title_tools =
        isEdit ? <></> :
            <a className="dropdown-toggle " onClick={e => toEdit()} data-toggle="dropdown" href="#A">
                <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">編輯</span>
            </a>
    var content =
        <>
            <div className="row">
                <div className="col-md-12">
                    {isEdit ?
                        <SingleRedio title={"啟用狀態"}
                            arr={isDisableItems}
                            val={isDisable} action={setIsDisable} />
                        : <SingleText title={"啟用狀態"} val={isDisable === "" ? "" : isDisable === 1 ? "停用中" : "啟用中"} size={4} />
                    }
                    <SingleText title={"最近啟用日期"} val={"-"} size={4} />
                    <SingleText title={"最近停用日期"} val={"-"} size={4} />
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-md-12">
                    {isEdit ?
                        <SingleInput title={"部門名稱"} val={departmentName} action={setDepartmentName} placeholder={"管理部、會計部"} size={4} />
                        :
                        <SingleText title={"部門名稱"} val={departmentName} size={4} />
                    }
                    {isEdit ?
                        <SingleSelect
                            title={"上級單位"}
                            val={managerDepartmentId}
                            attr={managerDepartmentList}
                            action={setManagerDepartmentId}
                            v={"departmentId"}
                            n={"departmentName"}
                            hasBlank={true}
                            size={4} />
                        :
                        <SingleText title={"上級單位"} val={managerDepartmentName} size={4} />
                    }
                    {isEdit ?
                        <SingleSelect
                            title={"部門屬性"}
                            val={categoryId}
                            attr={categoryList}
                            action={setCategoryId}
                            v={"categoryId"}
                            n={"categoryName"}
                            hasBlank={true}
                            size={4} />
                        :
                        <SingleText title={"部門屬性"} val={categoryName} size={4} />
                    }
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            {isEdit ?
                <>
                    <div className="hr-line-dashed"></div>
                    <div className="row m-t-sm">
                        <div className="col-md-12">
                            <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={saveDetail} isRight={true} />
                        </div>
                    </div>
                </>
                : <></>
            }
        </>
    return (
        <>
            <ContentBox title={title} title_tools={title_tools} content={content} hasDrawer={false} />
            {isEdit ? <></> :
                <DepartmentPositionList id={id} positionList={positionList} />
            }
            <SystemPromptInput />
        </>
    )
}